import i18n from '@/plugins/i18n';
import numeral from "numeral";

export default [
    {
        name: "image",
        title: i18n.t('Carrier'),
        width: "50px",
        filterable: true,
        togglable: true
    },
    {
        name: "carrier_name",
        title: "",
        filterable: true,
        togglable: true
    },
    {
        name: "delivery_time",
        title: i18n.t("Delivery Time"),
        filterable: true,
        togglable: true
    },
    {
        name: "pickup_locations",
        title: i18n.t("Pickup Locations"),
        filterable: true,
        togglable: true,
    },
    {
        name: "carrier_type",
        title: i18n.t("Carrier Type"),
        filterable: true,
        togglable: true,
    },
    {
        name: "price",
        title: i18n.t('Price'),
        filterable: true,
        togglable: true,
        formatter: (value) => {
            return '<span class="text-primary-600"><strong>฿' + numeral(value).format("0,0.00") + '</strong></span>';
        }
    }
];


// WEBPACK FOOTER //
// ./src/layouts/tenancy/admin/assets/rateTableField.js